import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import GlobeIllustration from 'svg/illustrations/Globe';

const Benefits = () => {
  const sections = [
    {
      title: 'Vida universitaria',
      subtitle: 'Parciales, campus, carreras y la transición del carnet estudiantil al mundo laboral.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
        </svg>
      ),
      color: colors.orange,
    },
    {
      title: 'Cultura pop y tendencias',
      subtitle: 'Redes, entretenimiento, música y lo que mueve la conversación digital de la nueva generación.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4V2m0 2h10M7 4v16m10-16v16M7 20h10M5 8h14M5 16h14" />
        </svg>
      ),
      color: colors.pink,
    },
    {
      title: 'Tecnología e IA',
      subtitle: 'Innovación, ética digital y el impacto de la inteligencia artificial en el día a día joven.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      color: colors.indigo,
    },
    {
      title: 'Educación financiera',
      subtitle: 'Finanzas personales, metas y primeros pasos en el mundo adulto — sin jerga pesada.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: colors.green,
    },
    {
      title: 'Entrevistas e invitados',
      subtitle: 'Artistas, referentes y voces que conectan con la audiencia joven de TNO Network.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
        </svg>
      ),
      color: colors.teal,
    },
    {
      title: 'Marcas juveniles',
      subtitle: 'Patrocinio orgánico ante audiencias digitales nativas que investigan y comparten en redes.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      color: colors.purple,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Temas
        </Typography>
        <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h3'} gutterBottom align={'center'} color={'primary'}>
          Conversación que suena a tu audiencia
        </Box>
        <Typography align={'center'} color="textSecondary" variant={'h6'}>
          2do Escalón aborda la vida real de quienes están en la recta final universitaria — con humor, datos y cercanía.
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} marginBottom={4} data-aos={'fade-up'}>
        <Box maxWidth={300} width={'100%'}>
          <GlobeIllustration width={'100%'} height={'100%'} />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box height={1} display={'flex'} flexDirection={'column'} data-aos={'fade-up'} data-aos-delay={i * 100}>
              <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} marginBottom={2}>
                <Box component={Avatar} width={60} height={60} marginRight={2} bgcolor={item.color[50]} color={item.color[900]}>
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant={'h6'} gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
